import objectPath from "object-path";
import { first_redirect } from "../../index";

/***
 * 进入路由前的操作
 */

export const tasks = [
  {
    name: "验证",
    handle() {
      if (!this.$route.query.lottery_type || !this.$route.query.category_id) {
        const path = first_redirect();
        this.$router.replace(path);
        return true;
      }
    }
  },
  {
    name: "数据重置",
    handle() {
      this.$store.commit("home_PK10/RESET_DATA");
    }
  },
  {
    name: "获取子列表",
    handle() {
      return this.$store.dispatch(
        "home_PK10/getTabsData",
        this.$route.query.category_id || 1
      );
    }
  },
  {
    name: "检查index参数",
    handle() {
      this.$store.commit("home_PK10/SET_CUR_TAB", this.$route.query.index || 0);
    }
  },
  {
    name: "获取最新注单列表",
    handle() {
      return this.$store.dispatch("home/getLotteryLatest");
    }
  },
  {
    name: "刷新用户信息",
    handle() {
      return this.$store.dispatch("root/updateUserInfo");
    }
  },
  [
    {
      name: "获取玩法对应赔率",
      handle() {
        const state = this.$store.state.home_PK10;
        return this.$store.dispatch("home_PK10/getCurOddsData", {
          sub_category_id: state.tabs[state.curTab].sub_category_id,
          lottery_type: this.$route.query.lottery_type || 1,
          category_id: this.$route.query.category_id || 1,
          played_name: state.lhOddsPlayedName
        });
      }
    },
    {
      name: "获取最新开奖结果",
      handle() {
        //const lottery_type = this.$route.query.lottery_type || 1;
        const state = this.$store.state.home_PK10;
        return this.$store.dispatch("home_PK10/getNewLotteryRes", {
          sub_category_id: state.tabs[state.curTab].sub_category_id,
          lottery_type: this.$route.query.lottery_type || 1,
        });
      }
    },
    {
      name: "获取长龙",
      handle() {
        const lottery_type = this.$route.query.lottery_type || 1;
        return this.$store.dispatch("home/getLongQueue", { lottery_type });
      }
    },
    {
      name: "获取最近开奖统计",
      handle() {
        //注释掉开奖统计，改快速投注
        //const lottery_type = this.$route.query.lottery_type || 1;
        //return this.$store.dispatch("home/getStatistics", { lottery_type });
      }
    }
  ]
];

/**
 * 页面定时任务
 * 离开页面后自动销毁
 * */
export const schedule = [
  {
    interval: 20,
    handle() {
      const state = this.$store.state.home_PK10;
      const sub_category_id =
        objectPath.get(state, `tabs.${state.curTab}.sub_category_id`) || "";
        this.$store.dispatch("root/updateUserInfo");
      return this.$store.dispatch("home_PK10/getCurOddsData", {
        sub_category_id,
        lottery_type: this.$route.query.lottery_type || 1,
        category_id: this.$route.query.category_id || 1,
        played_name: state.lhOddsPlayedName
      });
    }
  },
  {
    interval: 20,
    handle() {
      const state = this.$store.state.home_cc_ssc;
      const sub_category_id =
        objectPath.get(state, `tabs.${state.curTab}.sub_category_id`) || "";
        this.$store.dispatch("home_cc_ssc/getNewLotteryRes", {sub_category_id:sub_category_id,lottery_type:this.$route.query.lottery_type});
    }
  }
];



// WEBPACK FOOTER //
// ./src/pages/home/lh/index.js